import React from "react";
import {alpha, Card, CardActionArea, CardContent, CardHeader, Grid} from "@mui/material";
import DirectionsCarFilledTwoToneIcon from "@mui/icons-material/DirectionsCarFilledTwoTone";
import PhoneIcon from '@mui/icons-material/Phone';
import NavigationIcon from '@mui/icons-material/Navigation';
import CarRepairIcon from '@mui/icons-material/CarRepair';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CarRentalTwoToneIcon from "@mui/icons-material/CarRentalTwoTone";
import CreditScoreTwoToneIcon from "@mui/icons-material/CreditScoreTwoTone";
import EmojiTransportationTwoToneIcon from "@mui/icons-material/EmojiTransportationTwoTone";
import TireRepairIcon from '@mui/icons-material/TireRepair';
import {Link as RouterLink} from 'react-router-dom';
import Link from "@mui/material/Link";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";

export default function Main() {
    let pageItems = [
        {
            text: 'Каталог авто',
            icon: <DirectionsCarFilledTwoToneIcon fontSize="large" color="primary"/>,
            textSecondary: 'В наличии новые автомобили, электромобили и гибриды, а также автомобили с пробегом',
            link: "/listing"
        },
        {
            text: 'Авто под заказ',
            icon: <CarRentalTwoToneIcon fontSize="large" color="primary"/>,
            textSecondary: 'Доставка новых авто напрямую из Китая под ключ',
            link: "/vehicleOrder"
        },
        {
            text: 'Каталог мото',
            icon: <TwoWheelerIcon fontSize="large" color="primary"/>,
            textSecondary: 'Доставка новых мото напрямую из Китая под ключ, а также модели с пробегом любых брендов.',
            link: "/catalog-moto"
        },
        {
            text: 'Кредит/Лизинг',
            icon: <CreditScoreTwoToneIcon fontSize="large" color="primary"/>,
            textSecondary: 'Подбор кредитных и лизинговых программ на покупку авто совместно с банками-партнерами и лизинговыми компаниями',
            link: "/loan"
        },
        {
            text: 'Продать авто',
            icon: <EmojiTransportationTwoToneIcon fontSize="large" color="primary"/>,
            textSecondary: 'Помощь в продаже подержанных автомобилей / комиссия / обмен (trade-in)',
            link: "/commission"
        },
        {
            text: 'СТО',
            icon: <CarRepairIcon fontSize="large" color="primary"/>,
            textSecondary: 'Экспресс-замена масла / антикоррозийная обработка кузова / проточка тормозных дисков / заправка кондиционеров / детейлинг и др.',
            link: "/service"
        },
        {
            text: 'Шины',
            icon: <TireRepairIcon fontSize="large" color="primary"/>,
            textSecondary: 'Услуги по шиномонтажу и хранению шин',
            link: "/service"
        }/*,
        {
            text: 'Автомагазин',
            icon: <TireRepairIcon fontSize="large" color="primary"/>,
            textSecondary: 'Розничная и оптовая продажа запчастей, технических жидкостей, и аксессуаров для автомобилей',
            link: "/service"
        }*/
    ];

    const ContactLinks = () => {
        return (
            <Box
                py="2"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                }}
            >
                {[
                    {
                        text: "688-90-33",
                        icon: <PhoneIcon color="primary"/>,
                        link: "tel:6889033",
                    },
                    {
                        text: "Тимирязева 119/1",
                        icon: <NavigationIcon color="primary"/>,
                        link: "https://maps.app.goo.gl/GQwNKuHH6ZGMvFwP8",
                    },
                ].map((item, index) => (
                    <Link
                        component={RouterLink}
                        to={item.link}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                            flexShrink: 0,
                            fontSize: "calc(1rem + 0.5vw)",
                            color: "black",
                            marginRight: "5pt",
                            ":last-child": {
                                marginRight: 0,
                            },
                        }}
                    >
                        {item.icon}
                        <Typography component="span">{item.text}</Typography>
                    </Link>
                ))}
            </Box>

        );
    };

    return (
        <>
            <div className="hero pb-4">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-10">
                            <Grid
                                container
                                spacing={2} // Adjust spacing for grid items
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',  // Centers the grid items
                                    alignItems: 'stretch',     // Ensures items stretch uniformly
                                }}
                            >
                                {/* Hero Section */}
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={6}
                                    component="section"
                                    sx={{
                                        textAlign: 'center',
                                        color: 'black',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        width: '100%',
                                        paddingBottom: '10pt',
                                    }}
                                >
                                    <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 'calc(1rem + 0.5vw)' }}>
                                        Ваш автомобиль – наша забота!
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontSize: 'calc(1rem + 0.25vw)' }}>
                                        От покупки до ухода и продажи.
                                    </Typography>
                                    <ContactLinks />
                                </Grid>

                                {/* Card Section */}
                                {pageItems.map((item, index) => (
                                    <Grid
                                        item
                                        xs={12} // Full width for small screens
                                        sm={6}  // 2 items per row on medium screens
                                        md={3}  // 4 items per row on larger screens
                                        key={index}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'stretch',
                                            justifyContent: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <Card
                                            square
                                            sx={{
                                                minHeight: 200,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                border: '1px solid #ccc',
                                                backgroundColor: alpha('#fff', 0.4),
                                                width: '100%',
                                                position: 'relative',
                                                overflow: 'visible', // Allows icon to overflow beyond the card boundaries
                                                padding: 2,
                                            }}
                                        >
                                            {/* Overlay Icon */}
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: '-5%', // Adjust icon placement above the card
                                                    left: '10%',
                                                    transform: 'translate(-50%, 0)', // Center horizontally
                                                    zIndex: 10, // Ensure it appears on top of other elements
                                                    backgroundColor: 'rgba(255, 255, 255, 0.3)', // Optional: Add a background to the icon
                                                    borderRadius: '50%', // Optional: Circular background for the icon
                                                    padding: '8px', // Optional: Add spacing around the icon
                                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)', // Optional: Add shadow for emphasis
                                                }}
                                            >
                                                {item.icon}
                                            </Box>

                                            <CardActionArea
                                                component={RouterLink}
                                                to={item.link}
                                                sx={{
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <CardHeader
                                                    title={
                                                        <Typography
                                                            sx={{
                                                                fontSize: 'calc(1rem + 0.2vw)',
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            {item.text}
                                                        </Typography>
                                                    }
                                                />
                                                <CardContent
                                                    sx={{
                                                        flex: 1,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        paddingTop: 0,
                                                    }}
                                                >
                                                    <Typography variant="body2">
                                                        {item.textSecondary}
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>

            {/* About Section */}
            <div className="site-section">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-10">
                            <h3 className="mb-4 section-heading"><strong>Об Автосалоне</strong></h3>
                            <div className="row mb-3">
                                <div className="col-lg-4 text-center order-lg-2">
                                    <img src="/building_main.JPEG" alt="Автосалон" className="img-fluid mb-2" />
                                    <img src="/cars.JPG" alt="Автоплощадка" className="img-fluid mb-4" />
                                </div>
                                <div className="col-lg-8 ml-auto order-lg-1">
                                    <p className="mb-4">
                                        «БелАвтоЭксперт» - автомобильная компания, которая занимается продажей и обслуживанием автомобилей.
                                        В нашем автосалоне Вы найдете автомобили известных мировых брендов на любой вкус
                                        и бюджет.
                                    </p>
                                    <p className="mb-3">
                                        Отличительные особенности нашей компании - профессионализм сотрудников и
                                        индивидуальный подход к каждому клиенту.
                                    </p>
                                    <p className="mb-3">
                                        Мы всегда на связи. С удовольствием готовы помочь c покупкой и продажей
                                        автомобиля.
                                    </p>
                                    <p className="mb-3">
                                        У нас Вы можете купить любое транспортное средство на выгодных условиях,
                                        поставить свою машину на продажу по Вашей цене, а также воспользоваться
                                        качественными услугами нашего автосервиса.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>



    )

}
